<script setup lang="ts">
  import { provideRecentSearch } from '../../utils/search-providers'
  import { useLocalStorage } from '@gat-ship/utils'
  import { type RecentSearch } from '../../utils/search-types'
  import { computed } from 'vue'
  const _recentSearches = useLocalStorage<RecentSearch[]>(
    `gs-recent-searches`,
    []
  )

  const recentSearchItems = computed(() => {
    return _recentSearches.value
  })

  function addRecentSearch(search: RecentSearch) {
    console.log('adding recent search', search)
    const deduped = _recentSearches.value.filter(
      (item) =>
        !(
          item.context === search.context &&
          item.searchString === search.searchString
        )
    )
    _recentSearches.value = [search, ...deduped]
  }

  const clearRecentSearches = () => {
    _recentSearches.value = []
    console.log('cleared recentSearches', _recentSearches.value)
  }

  provideRecentSearch({
    recentSearchItems,
    clearRecentSearches,
    addRecentSearch
  })
</script>

<template>
  <slot />
</template>
